import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { OrderPipe } from 'ngx-order-pipe';
import { DialogService } from 'primeng/dynamicdialog';
import { Observable } from 'rxjs';
import { map, shareReplay, tap } from 'rxjs/operators';
import { ConferenceResource, IConferenceCurrent } from 'src/app/models/iconference.interface';
import { IKeyValue } from 'src/app/models/ikeyvalue.interface';
import { ConferenceService } from 'src/app/services/data/conference.service';

@UntilDestroy()
@Component({
  selector: 'app-current-conference-navbar',
  templateUrl: './current-conference-navbar.component.html',
  styleUrls: ['./current-conference-navbar.component.css'],
  providers: [DialogService]
})
export class CurrentConferenceNavbarComponent implements OnInit {
  showDialog: boolean = false;
  dialogRef: any;

  currentConference$ = this._cnf.currentConference$.pipe(
    shareReplay()
  );

  selected: IConferenceCurrent;
  items$: Observable<IConferenceCurrent[]> = this._cnf.getAll().pipe(
    map((data: ConferenceResource[]) => this._order.transform(data, "dateStart", true).map(r => ({
      id: r.id,
      name: `${r.name} (${r.cityName ?? ''}, ${r.dateStart.split('T')[0]})`,
      alias: r.alias
    } as IConferenceCurrent))),
    shareReplay()
  );

  constructor(
    private _cnf: ConferenceService,
    private _dlg: DialogService,
    private _order: OrderPipe
  ) { }

  ngOnInit(): void {
  }

  onChangeCurrentConference() {
    this.showDialog = true;
  }

  onResetCurrentConference() {
    this._cnf.resetCurrentConference();
  }

  onCancel() {
    this.showDialog = false;
  }

  onSubmit(obj: IConferenceCurrent) {
    const form = {
      id: obj.id,
      name: obj.name,
      updatedAt: new Date(),
      alias: obj.alias
    } as IConferenceCurrent;
    this._cnf.setCurrentConference(form);
    this.showDialog = false;
  }
}
